import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const CheckIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11.0241 8.07">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                // eslint-disable-next-line max-len
                d="M11.0241 0.827365L10.1974 0L3.78721 6.41515L0.82672 3.45234L0 4.27971L2.96049 7.24251L2.96037 7.24264L3.78709 8.07L11.0241 0.827365Z"
                fill="currentColor"
            />
        </svg>
    </IconWrapper>
));
